import type { ComponentType, SVGProps } from "react";

import { DocumentIcon, ImportIcon } from "@/components/icons";
import { ROUTES } from "@/config/routes";

/** Whether a tool is ready for the team to use or still being built. */
export type ToolStatus = "live" | "unavailable";

/** A single tool shown on the Tools page. Presentational only for now. */
export interface Tool {
  /** Stable id, also used as the React key. */
  id: string;
  /** Tool name shown as the card title. */
  name: string;
  /** One-line description of what the tool does. */
  description: string;
  /** Client the tool was built for. */
  client: string;
  /** Availability state, drives card treatment (e.g. faded unavailable tools). */
  status: ToolStatus;
  /** Stroke icon component, inherits currentColor. */
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** In-app route the card links to. Omit for tools without a page yet. */
  path?: string;
}

/**
 * Example tools the team has built. This is sample data so we can see the
 * page layout — add or edit entries here as tools come online.
 */
export const TOOLS: readonly Tool[] = [
  {
    id: "prospect-letter-generator",
    name: "Prospect Letter Generator",
    description:
      "Upload a CSV of prospects and generate a personalised PDF letter for each, plus a sheet of mailing labels.",
    client: "IOG",
    status: "live",
    icon: DocumentIcon,
    path: ROUTES.prospectLetter,
  },
  {
    id: "netsuite-contacts-import",
    name: "NetSuite Contacts Import",
    description:
      "Upload a NetSuite contacts export (.xlsx) and download two ready-to-import CSVs — one for email, one for SMS.",
    client: "LOAD",
    status: "live",
    icon: ImportIcon,
    path: ROUTES.netsuiteContacts,
  },
];
